import React from 'react';
import { Ban, Check, RedoAlt } from '@alefeducation/ui-elements-library-icons';
import useMemberActions, { MemberActionsEnum } from './hooks/useMemberActions';
import {
  DISABLE_USER_TEXT,
  ENABLE_USER_TEXT,
  RESET_MFA_TEXT,
} from '../../utils/constants';
import { resetMFA } from '../../utils/resetMfaUtils';
import { Member } from '../../apollo/queries';
import DataGridActions from '../DataGrid/DataGridActions';
import { ConfirmModal } from '../../utils/ConfirmModal';

const MEMBER_PAGE_TOAST_ID = 'members-page-toast';

export interface MemberActionsProps {
  member: Member;
  refetch: () => void;
}

export const MemberActions: React.FC<MemberActionsProps> = ({
  member,
  refetch,
}) => {
  const { dialogData, setSelectedAction } = useMemberActions({
    setActive: refetch,
    member,
  });

  const actions = [
    {
      name: member.enabled ? DISABLE_USER_TEXT : ENABLE_USER_TEXT,
      icon: member.enabled ? <Ban /> : <Check />,
      callback: () =>
        setSelectedAction(
          member.enabled
            ? MemberActionsEnum.DISABLE_USER
            : MemberActionsEnum.ENABLE_USER,
        ),
      shouldRender: true,
      testId: member.enabled
        ? `disable-user-button-${member.id}`
        : `enable-user-button-${member.id}`,
    },
    {
      name: RESET_MFA_TEXT,
      icon: <RedoAlt />,
      callback: () =>
        member.uuid && resetMFA(member.uuid, MEMBER_PAGE_TOAST_ID),
      shouldRender: !!member.uuid,
      testId: `reset-mfa-user-button-${member.uuid}`,
    },
  ];

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <DataGridActions row={member} actions={actions} />
      <ConfirmModal
        open={dialogData.isOpen}
        heading={dialogData.title}
        message={dialogData.message}
        modalVisibility={() => setSelectedAction('')}
        onYesClick={dialogData.action}
      />
    </div>
  );
};
